import { Component, Input, SecurityContext } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

import { VoiceShot } from '@app/models';

@Component({
    selector: 'app-voiceshot-dialog',
    templateUrl: './voiceshot-dialog.component.html',
    styleUrls: ['./voiceshot-dialog.component.scss'],
    standalone: false
})
export class VoiceshotDialogComponent {
  @Input() recipients: any;
  @Input() availableVoiceshots: VoiceShot[];

  chosenVoiceshot: VoiceShot;
  sanitizedUrl: string = null;
  confirmText: string = 'Send Voiceshot';

  constructor(
    public dialogRef: MatDialogRef<VoiceshotDialogComponent>,
    private sanitizer: DomSanitizer
  ) { }


  voiceshotSelected(_voiceshot) {
    this.sanitizedUrl = this.sanitizer.sanitize(SecurityContext.URL, this.chosenVoiceshot?.path + this.chosenVoiceshot?.filename);
  }


  getSantizeUrl() {
    return this.sanitizer.sanitize(SecurityContext.URL, this.chosenVoiceshot?.path + this.chosenVoiceshot?.filename);
  }


  closeDialog(_confirmed) {
    return this.dialogRef.close({
      confirmed: _confirmed,
      voiceshotChosen: this.chosenVoiceshot
    });
  }
}